<template>
<div>

    <el-crud :baseUrl="'/users'" 
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        :filters="filters"
        ref="crud"
        @newItem="editPassword = true"
        @editItem="editPassword = false">


        <template slot="crudFiltersDescription">
            <div v-if="filters.functional_area_id != null && filters.functional_area_id.length">Área: <strong>{{functional_area_name}}</strong></div>
            <div v-if="filters.profile != null && filters.profile.length">Perfil: <strong>{{role_name}}</strong></div>
            <div v-if="filters.filter">Empleado: <strong>{{filters.filter}}</strong></div>
            <div v-if="!areFilters"><strong>Datos sin filtrar</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Área" label-width="120px" prop="functional_area_id">
                        <el-select multiple v-model="filters.functional_area_id" filterable placeholder="Seleccione">
                            <el-option label="Acceso a todas" :value="0"></el-option>
                            <el-option
                                v-for="item in functional_areas"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Perfil" label-width="120px" prop="profile">
                        <el-select multiple v-model="filters.profile" filterable placeholder="Seleccione">
                            <el-option
                                v-for="item in roles"
                                :key="item.value"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Usuario" label-width="120px" prop="filter">
                        <el-input placeholder="Nombre o e-mail" v-model="filters.filter" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>


        <template slot="table">
            <el-table-column
                prop="name"
                label="Nombre">
            </el-table-column>
            <el-table-column
                prop="email"
                label="Email">
            </el-table-column>
            <el-table-column
                prop="profile"
                label="Perfil">
            </el-table-column>
            <el-table-column
                label="Áreas">
                <template slot-scope="scope">
                    <el-tag v-for="item in scope.row.functional_areas" :key="scope.row.id+item.company_id_number" size="mini">{{item.description}}</el-tag>
                </template>
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Nombre" label-width="240px" :prop="resource.name" :error="scope.errors.name">
                <el-input v-model="resource.name" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Email" label-width="240px" :prop="resource.email" :error="scope.errors.email">
                <el-input v-model="resource.email" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Contraseña" label-width="240px" v-if="!editPassword">
                <a href="#" @click.prevent="editPassword = true">Editar</a>
            </el-form-item>
            <el-form-item label="Contraseña" label-width="240px" :prop="resource.password" :error="scope.errors.password" v-if="editPassword">
                <el-input v-model="resource.password" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Confirmación de Contraseña" label-width="240px" :prop="resource.passwordConfirm" :error="scope.errors.passwordConfirm" v-if="editPassword">
                <el-input v-model="resource.passwordConfirm" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Perfil" label-width="240px" :prop="resource.profile" :error="scope.errors.profile">
                <el-select v-model="resource.profile" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in availableRoles"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Permiso Bonificaciones" label-width="240px" v-if="isSuperAdmin">
                <el-checkbox v-model="resource.can_edit_bonuses">
                    Permitir editar bonificaciones guardadas (bonuses.edit)
                </el-checkbox>
            </el-form-item>
            <el-form-item label="Áreas" label-width="240px" :error="scope.errors.functionalAreas">
                <el-repetitive-field v-model="resource.functionalAreas.value" :buttonText="'Área'" :default="{functional_area_id:null}">
                    <template slot-scope="props">
                        <el-form-item :prop="props.item.functional_area_id">
                            <el-select v-model="props.item.functional_area_id" filterable placeholder="Seleccione" size="mini">
                                <el-option label="TODAS" :value="0"></el-option>
                                <el-option
                                    v-for="item in functional_areas"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-repetitive-field>
            </el-form-item>
        </template>
    </el-crud>

</div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';
    import el_crud from '../el-crud.vue';
    import el_repetitive_field from '../el-repetitive-field.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nuevo Usuario',
                    EditItemTitle: 'Editar Usuario',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el usuario. Desea continuar?'
                },
                filters: {
                    functional_area_id: null,
                    profile: null,
                    filter: null,
                },
                resource:{
                    name: null,
                    email: null,
                    password: null,
                    passwordConfirm: null,
                    profile: null,
                    can_edit_bonuses: false,
                    functionalAreas:{
                        value: null,
                        setValue: (value) => {
                            this.resource.can_edit_bonuses = value ? (value.can_edit_bonuses || false) : false;
                            this.resource.functionalAreas.value = [];
                            if (value != null) {
                                _.each(value.functional_areas, (functionalArea) => {
                                    this.resource.functionalAreas.value.push({
                                        functional_area_id: functionalArea.id.toString()
                                    });
                                });
                            }
                        }
                    },
                },
                editPassword: false,
            };
        },
        components: {
            'el-crud': el_crud,
            'el-repetitive-field': el_repetitive_field
        },
        computed: {
            ...mapGetters(["functional_areas", "roles"]),
            isSuperAdmin() {
                if (!this.$auth) return false;
                const userProf = this.$auth.user && this.$auth.user.profile 
                    ? (typeof this.$auth.user.profile === 'object' ? this.$auth.user.profile.profile : this.$auth.user.profile) 
                    : null;
                return ['SADM', 'SuperAdmin', 'SuperAdministrador', 'SUPER_ADM'].includes(userProf);
            },
            availableRoles() {
                if (this.isSuperAdmin) {
                    return this.roles;
                }
                return (this.roles || []).filter(item => !['SADM', 'SuperAdmin', 'SuperAdministrador', 'SUPER_ADM'].includes(item.value));
            },
            'functional_area_name': function () { return getOptionLabel(this.functional_areas, this.filters.functional_area_id) },
            'role_name': function () { return this.filters.profile.join(' - ') },
            'areFilters': function () {
                return (this.filters.functional_area_id != null && this.filters.functional_area_id.length > 0)
                        || (this.filters.profile != null && this.filters.profile.length > 0)
                        || this.filters.filter != null;
            }
        },
        mounted() {
            this.fetchFunctionalAreas();
            this.fetchRoles();

            // axios.get('/api/functionalareas/options').then((response) => {
            //     _.each(response.data, (description, id) => {
            //         this.functionalAreasOptions.push({label: description, value: id})
            //     });
            //     this.functionalAreasOptions = _.sortBy(this.functionalAreasOptions, 'label');
            //     this.functionalAreasOptions.unshift({label: 'TODAS', value: '0'});
            // });
            // axios.get('/api/roles/options').then((response) => {
            //     _.each(response.data, (description, id) => {
            //         this.profiles.push({label: description, value: description})
            //     });
            //     this.profiles = _.sortBy(this.profiles, 'label');
            // });
        },
        methods: {
            ...mapActions(["fetchFunctionalAreas", "fetchRoles"]),
        }

    }
</script>
